import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=30355133"
import script from "@/views/ForgotPassword/ForgotPassword.ts?vue&type=script&lang=ts&external"
export * from "@/views/ForgotPassword/ForgotPassword.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/ForgotPassword/forgot-password.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports